import React, { Component } from 'react';
import Stack from '@mui/material/Stack';
import Drawing from './Drawing';
import ControlPanel from './ControlPanel';

class App extends Component {

  render() {
    // Stage is a div container
    // Layer is actual canvas element (so you may have several canvases in the stage)
    // And then we have canvas shapes inside the Layer
    return (
      <Stack spacing={2} direction="row">
        <ControlPanel/>
        <Drawing/>
      </Stack>
    );
  }
}


export default App;
